import { useContext } from 'react';
import { PermissionContext } from './PluginContext';

export function usePluginContext() {
	return useContext(PermissionContext);
}
